import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button } from 'reactstrap';

import OrderDialog from '../../Modal/Order/Order';

import {
  renderOrderStatus,
  renderOrderSide,
  renderOrderQuantity,
  renderOrderQuantityType,
  renderOrderSymbol,
  renderOrderPrice,
  renderOrderTimeFrame,
  renderOrderAccount,
  renderExecutionsAvg,
} from '../../Order/Item';
import { getOrderStats, Mode } from '../../../utils';
import { localDateTime } from '../../../utils/Helper';

const Offer = ({ order: o, userType, services }) => {
  const [modal, setModal] = useState(false);

  const toggleModal = () => {
    setModal((m) => !m);
  };

  const order = { ...o };
  order.stats = getOrderStats(order);
  order.OrderInitDate = localDateTime(o.OrderInitDate);
  order.OrderModifiedDate = localDateTime(o.OrderModifiedDate);

  return (
    <React.Fragment>
      <Row>
        <Col>
          {' '}
          {renderOrderStatus(order)}
          {' '}
          {renderOrderSide(order)}
          {' '}
          {renderOrderQuantity(order)}
          {' '}
          {renderOrderQuantityType(order)}
          {' '}
          {renderOrderSymbol(order)}
          {' @ '}
          {renderOrderPrice(order)}
          {' '}
          {renderOrderTimeFrame(order)}
          {' '}
          {renderOrderAccount(order)}
          {' '}
          {renderExecutionsAvg(order)}
        </Col>
      </Row>
      <Row style={{ marginTop: '1rem', marginBottom: '-1rem' }}>
        <Col>
          <Button
            color="primary"
            onClick={toggleModal}
          >
            More Info
          </Button>
        </Col>
      </Row>
      {modal && (
        <OrderDialog
          open
          toggle={toggleModal}
          userType={userType}
          mode={Mode.READONLY}
          order={order}
          {...services}
        />
      )}
    </React.Fragment>
  );
};

Offer.propTypes = {
  order: PropTypes.object.isRequired,
  userType: PropTypes.string.isRequired,
  services: PropTypes.object.isRequired,
};

export default Offer;
